import { useQuery } from '@tanstack/react-query';

import servicePeople from 'services/people';

/**
 * @typedef {Object} Panel
 * @property {number} id
 * @property {string} title
 */

/**
 * Query hook for fetching all panels for the current account.
 *
 * @param {import('@tanstack/react-query').UseQueryOptions<Panel[]>} [options={}]
 * @returns {import('@tanstack/react-query').UseQueryResult<Panel[]>}
 */
export const usePanelsQuery = (options = {}) => {
    return useQuery({
        queryKey: ['panels'],
        queryFn: () => servicePeople.getPanels(),
        ...options
    });
};
